import { installClickEvents } from "./events/click.js";
import { installChangeEvents } from "./events/change.js";
import { installInputEvents } from "./events/input.js";
import { installSubmitEvents } from "./events/submit.js";
export function installControllers() {
  installClickEvents();
  installChangeEvents();
  installInputEvents();
  installSubmitEvents();
}
